import { useEffect, useState } from "react";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";

import { Tabla } from "../../../components/Table/Table";
import { v4 as uuidv4 } from "uuid";
import icon from "../../../assets/static/images/secciones/comercios.png";
import DescargarExcel from "../../../components/DescargarExcel/DescargarExcel";
import AlertInfo from "../../../components/AlertInfo";
import { getAbogados } from "../../../redux/Sections/Abogados/actions";
import { setLoading } from "../../../redux/Loading/actions";
import { situacionesService } from "../../../_services/situaciones.service";
import { getComercios } from "../../../redux/Sections/Comercios/actions";
import NewConvenio from "../Convenios/Components/NewConvenio";
import { RowDeudas } from "./RowDeudas/RowDeudas";
import { Filter } from "./Filter/Filter";
import { getConvCaracters, getConvEstado, getConvFormaPagos } from "../../../redux/Sections/Convenios/actions";

const columns = [
  {
    title: "NÚMERO DE COMERCIO",
    dataIndex: "NRO_COMERCIO",
    key: "NRO_COMERCIO",
  },
  {
    title: "SUCURSAL",
    dataIndex: "SUCURSAL",
    key: "SUCURSAL",
  },
  {
    title: "CONTRIBUYENTE",
    dataIndex: "NOMBRE",
    key: "NOMBRE",
  },
  {
    title: "FANTASIA",
    dataIndex: "NOM_FANTASIA",
    key: "NOM_FANTASIA",
  },
  {
    title: "DOMICILIO",
    dataIndex: "DOMICILIO",
    key: "DOMICILIO",
  },
];


const formatData = (dataTable) => {
  if (dataTable && dataTable?.length) {
    return dataTable.map((e, i) => {
      const {
        CALLE, NRO,
        PAR_PROVINCIAL,
        CIRCUNS,
        SECCION,
        CHACRA_NRO,
        CHACRA_LET,
        QUINTA_NRO,
        QUINTA_LET,
        FRACCION_NRO,
        FRACCION_LET,
        MANZANA_NRO,
        MANZANA_LET,
        PARCELA_NRO,
        PARCELA_LET,
        UNI_FUNCIONAL,
      } = e;

      return {
        id: i,
        uuid: uuidv4(),
        ...e,
        DOMICILIO: `${CALLE || ""} ${NRO || ""}`,
        NOMENCLATURA: `
        ${CIRCUNS ? `CIRCUNS: ${CIRCUNS}` : ""} ${SECCION ? `- SECCION: ${SECCION}` : ""} ${CHACRA_NRO ? `- CHACRA_NRO: ${CHACRA_NRO}` : ""} ${CHACRA_LET ? `- CHACRA_LET: ${CHACRA_LET}` : ""}
        ${QUINTA_NRO ? `- QUINTA_NRO: ${QUINTA_NRO}` : ""} ${QUINTA_LET ? `- QUINTA_LET: ${QUINTA_LET}` : ""} ${FRACCION_NRO ? `- FRACCION_NRO: ${FRACCION_NRO}` : ""} ${FRACCION_LET ? `- FRACCION_LET: ${FRACCION_LET}` : ""}
        ${MANZANA_NRO ? `- MANZANA_NRO: ${MANZANA_NRO}` : ""} ${MANZANA_LET ? `- MANZANA_LET: ${MANZANA_LET}` : ""} ${PARCELA_NRO ? `- PARCELA_NRO: ${PARCELA_NRO}` : ""} ${PARCELA_LET ? `- PARCELA LET: ${PARCELA_LET}` : ""}
        ${UNI_FUNCIONAL ? `- SUBPARCELA: ${UNI_FUNCIONAL}` : ""}`,
        PARTIDA: `${PAR_PROVINCIAL ? `PARTIDA: ${PAR_PROVINCIAL}` : ""}`
      };
    });
  } else {
    return [];
  }
};

const Comercios = ({ getData, data, getAbogados, abogados, getConvCaracters, getConvEstado, getConvFormaPagos }) => {
  const dispatch = useDispatch();
  const [showFilter, setShowFilter] = useState(true);
  const { showTable } = useSelector(state => state.dashboard);
  const [situaciones, setSituaciones] = useState([]);
  const [newConvenio, setNewConvenio] = useState(false);

  useEffect(() => {
    const getData = async () => {
      dispatch(setLoading(true));

      let response = await situacionesService.getSituaciones();

      if (response?.length) {
        setSituaciones(response.map(e => {
          return {
            ...e,
            value: e.CODIGO,
            label: e.DETALLE_SITUACION
          };
        }));

        dispatch(setLoading(false));
      }
      else {
        dispatch(setLoading(false));
      }
    };

    getData();
  }, []);

  useEffect(() => {
    if (showTable) {
      setShowFilter(false);
    }

  }, [showTable]);

  useEffect(() => {
    getAbogados();
    getConvCaracters();
    getConvFormaPagos();
    getConvEstado();
  }, []);

  const action = async (data) => {
    try {
      dispatch(setLoading(true));
      
      await getData(data);

      dispatch(setLoading(false));
    }
    catch (err) {
      console.log(err);
    }
  };
  // {
  //   "NRO_COMERCIO": "1664900",
  //   "NOMBRE": "RETTA DANIEL SANTOS",
  //   "NOM_FANTASIA": "RETTA DANIEL",
  //   "RUBRO": "84",
  //   "COD_CALLE": "122",
  //   "CALLE": "FRANCIA",
  //   "NRO": "253",
  //   "COD_POS": "2900",
  //   "COD_POSTAL": "2900",
  //   "COD_LOC": "2900",
  //   "INGR_BRUTOS": "20-14898225-3",
  //   "CUIT": "20-14898225-3",
  //   "FECHA_APERTURA": "01/09/1995",
  //   "FECHA_HABILITACION": "01/12/1999",
  //   "RESOL_NRO": "00/00/00",
  //   "EXPED_NRO": "009609",
  //   "EXPED_ANIO": "95",
  //   "EXPED_CESE_NRO": "000000",
  //   "SUP_COMERCIAL": "0",
  //   "MTS_ESPACIO_P": "0",
  //   "COD_DELEG": "1",
  //   "OBSERVACIONES": "Varios: ver observ.",
  //   "FECHA_ALTA": "01/09/1995",
  //   "RESP_PAGO": "RETTA DANIEL SANTOS",
  //   "DP_COD_CALLE": "122",
  //   "DP_CALLE": "FRANCIA",
  //   "DP_NRO": "253",
  //   "DP_COD_POS": "2900",
  //   "DP_COD_POSTAL": "2900",
  //   "DP_COD_LOC": "2900",
  //   "DP_COD_PRO": "BSAS",
  //   "DETALLE": "Mig:22/12/2021",
  //   "ITEM": "1",
  //   "TO_VISIBLE": "S",
  //   "TO_OPERABLE": "S",
  //   "SUCURSAL": "0000"
  // }
  function exportData(list) {
    console.log(list);
    if(list?.length){
      let filename = `comercios_${new Date().getTime()}.xlsx`;

      const dataList = list.map((e) => {
        return {
          "NRO COMERCIO": e.NRO_COMERCIO,
          "SUCURSAL": e.SUCURSAL,
          "NOMBRE FANTASIA": e.NOM_FANTASIA,
          "DOMICILIO": `${e.CALLE || ""} ${e.NRO || ""} ${e.PISO ? ` - PISO: ${e.PISO}` : ""} ${e.DEPT ? `DEPT: ${e.DEPT}` : ""}`,
          "BARRIO": e.BARRIO,
          "CUIT": e.CUIT,
          "FECHA DE APERTURA": e.FECHA_APERTURA,
          "FECHA DE HABILITACION": e.FECHA_HABILITACION,
          "NRO DE EXPEDIENTE": e.EXPED_NRO,
        };
      });

      let name = "Inmuebles";

      return {
        dataList,
        filename,
        name
      };
    }  else{
      return [];
    }
  
  }

  const handleNewConvenio = () => {
    setNewConvenio(!newConvenio);
  };

  return (
    <div className="section-container section-content">
      <div className="section-title d-flex align-items-center">
        <img src={icon} alt="contribuyente" className="opacity-icon" />
        <span>Comercios</span>
      </div>
      {
        newConvenio ?
          (
            <div className="new-convenio">
              <NewConvenio handleNewConvenio={handleNewConvenio} abogados={abogados} comercios />
            </div>
          ) :
          (
            <>
              <div className="w-100 d-flex justify-content-end pr-5">
                <Button className="custom-button" style={{ maxWidth: 160 }} onClick={handleNewConvenio}>Nuevo Convenio</Button>
              </div>
              <div className="buttons-filter">
                <h3 className="mr-3">Filtros:</h3>
                <div className="button-filter">
                  {showFilter ? (
                    <Button
                      variant="danger"
                      onClick={() => setShowFilter(false)}
                      className="danger-button d-flex align-items-center"
                      style={{ maxWidth: 105 }}
                    >
                      <FontAwesomeIcon icon={faArrowDown} size="1x" /><span className="ml-2">Ocultar</span>
                    </Button>
                  )
                    : (
                      <Button
                        onClick={() => setShowFilter(true)}
                        className="custom-button d-flex align-items-center"
                        style={{ maxWidth: 105 }}
                      >
                        <FontAwesomeIcon icon={faArrowUp} size="1x" /><span className="ml-2">Mostrar</span>
                      </Button>
                    )}
                </div>
              </div>
              <div className="section-filter">
                <Filter showFilter={showFilter} setShowFilter={setShowFilter} style={{ marginBottom: "30px" }} action={action} />
              </div>
              {showTable ? (
                <div className="section-table">
                  {data?.length ? (
                    <AlertInfo>
                      <div className="d-flex align-items-center">
                        Haga click en
                        <div className="d-flex mx-1">
                          <button type="button" className="ant-table-row-expand-icon ant-table-row-expand-icon-collapsed" aria-label="Expand row"></button>
                        </div>
                        para ver la deuda del inmueble.
                      </div>
                    </AlertInfo>
                  ) : null}
                  <Tabla
                    dataList={formatData(data)}
                    columns={columns}
                    expandable={true}
                    selection={false}
                    RowData={RowDeudas}
                    inmuebles={true}
                    abogados={abogados}
                    situaciones={situaciones}
                  />
                  <div className="mt-3">
                    <div style={{ maxWidth: 170 }}>
                      <DescargarExcel data={exportData(data)} />
                    </div>
                  </div>
                </div>
              ) : null}
            </>
          )
      }
    </div>
  );
};


const mapStateToProps = (state) => {
  return {
    data: state.dashboard.comerciosList,
    abogados: state.dashboard.abogadosList,
    loading: state.dashboard.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getData: (data) => dispatch(getComercios(data)),
    getAbogados: () => dispatch(getAbogados()),
    getConvCaracters: () => dispatch(getConvCaracters()),
    getConvEstado: () => dispatch(getConvEstado()),
    getConvFormaPagos: () => dispatch(getConvFormaPagos()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Comercios);